enum JourneyStage {
	AppointmentTypeSelection,
	PatientAttributesQuestionaire,
	AppointmentTimeSelection,
	BookingConfirmed,
	TermsAndConditionsDeclined,
	TermsAndConditionsAccepted,
	VerifyPasscodeInput,
	PrepaymentFailed,
	PrepaymentAborted,
	PersonalDetailsInput,
	HealthCoverDetailsInput,
	PrepaymentSuccessful,
	TermsAndConditions,
	AppointmentPrepayment,
}

export default JourneyStage;
